module.exports = __webpack_public_path__ + "img/MoskauGrotesk-Light.cc662551.svg";